export default {"src":"/_next/static/media/jp.ba586ad1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};